/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apartment_Sold_OutInputs */

const en_apartment_sold_out = /** @type {(inputs: Apartment_Sold_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No free dates in the next 90 days`)
};

/**
* | output |
* | --- |
* | "No free dates in the next 90 days" |
*
* @param {Apartment_Sold_OutInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const apartment_sold_out = /** @type {((inputs?: Apartment_Sold_OutInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apartment_Sold_OutInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_apartment_sold_out(inputs)
});